import { createApp } from '@app/adapters/create-app'

import WorkflowList from '../components/workflow-list.vue'

window.onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='workflow-list']").each(function () {
    const { workflowId, isOnWorkflowPage, disabledMessage } = this.dataset

    createApp(WorkflowList, {
      workflowId: workflowId ? parseInt(workflowId, 10) : null,
      isOnWorkflowPage: isOnWorkflowPage === 'true',
      disabledMessage,
    }).mount(this)
  })
})
